import { render, staticRenderFns } from "./NewEditorModal.vue?vue&type=template&id=fb7aa16c&scoped=true&"
import script from "./NewEditorModal.vue?vue&type=script&lang=js&"
export * from "./NewEditorModal.vue?vue&type=script&lang=js&"
import style0 from "./NewEditorModal.vue?vue&type=style&index=0&id=fb7aa16c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb7aa16c",
  null
  
)

export default component.exports